import { FC } from 'react';

import { EnumRadioGroup } from '../components/enumRadioGroup';
import { EnumRadioButton } from '../components/enumRadioButton';
import { OppvarmingVarmepumpe } from '../../../../../../../types/registration/userInput';

import { deriveFordelingRadioValue, VarmepumpeFordeling } from './utils';

interface Props {
  value?: OppvarmingVarmepumpe;
  onChange: (value: VarmepumpeFordeling) => void;
}

export const VarmepumpeFordelingRadio: FC<Props> = ({ onChange, value }) => (
  <EnumRadioGroup
    labelKey="register.tekniskUtstyr.oppvarmingVarmepumpe.fordelingSystem.label"
    helperTextKey="register.tekniskUtstyr.oppvarmingVarmepumpe.fordelingSystem.information"
    onChange={(val) => onChange(val as VarmepumpeFordeling)}
    value={deriveFordelingRadioValue(value)}
  >
    <EnumRadioButton i18nPrefix="register.tekniskUtstyr" value={VarmepumpeFordeling.Punktoppvarming} />
    <EnumRadioButton i18nPrefix="register.tekniskUtstyr" value={VarmepumpeFordeling.VannbarenVarme} />
    <EnumRadioButton i18nPrefix="register.tekniskUtstyr" value={VarmepumpeFordeling.Ventilasjon} />
  </EnumRadioGroup>
);
